import React from 'react';
import './mbko.css'
import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import img77 from '../style/mbko_schedule.png'

function MLG(props) {
    useEffect(() => {
        window.scrollTo(0, 0); // 스크롤 위치를 (0, 0)으로 조정
      }, []);
    
    return (
        <>
            <div className='bg-color'>
                <div className="background-image container container1">
                    <div className="MLG-image">
                         <div className='back-btn'>
                    <Link to="/mbko" style={{textDecoration:'none'}}>
                            {/* <img className='back-btn' src={img13}>

</img> */}
                        　　　　　　</Link>
                        </div>
<div className='logo-image container container1' >
    </div>
                        <div className='game-top2'>
                        <p style={{marginBottom:3}}>
                        <strong>·대회 개요</strong>
                        </p>
                        <p style={{marginBottom:30}}>
                        2023 MbKO는 국내 최대 규모의 다종목 동시 진행 전국 보드게임 대회입니다. b-스포츠 문화의 정착과 프로 리그 육성을 위한 대회 발전에 기여 하고자 (사)한국브레인스포츠연맹, (재)수원컨벤션센터, (주)미어캣커뮤니케이션즈가 주최·주관하여 선정된 8개 종목 11개부문에 대한 전국 예선을 거쳐 대규모의 본선 대회를 개최합니다. 제2회 MbKO 한국 대회를 함께 해 주셔서 감사드리며 해를 거듭하며 발전하는 모습으로 보답하겠습니다. 
                        </p>
                        <p></p>


                        <p style={{marginBottom:3}}>
                        <strong>·대회 안내</strong>
                        </p>
                        <p style={{marginBottom:0}}>대회명 : 2023 제2회 미어캣 b-스포츠 코리아 오픈&#40;MbKO&#41;</p>
                        <p style={{marginBottom:0}}>장 소 : 수원컨벤션센터 1층 회의실 1,2,3대회장</p>
                        <p style={{marginBottom:30}}>날 짜 : 2023.10. 07&#40;토&#41; ~ 08&#40;일&#41; 2일간
                        </p>

                        <p style={{marginBottom:3}}>
                        <strong>·예선 개최 종목</strong>
                        </p>
                        <p style={{marginBottom:0}}>일반부: 캐스캐디아, 로그</p>
                        <p style={{marginBottom:0}}>초등부: 캐스캐디아, 종이와바다</p>
                        <p style={{marginBottom:0}}>예선일시 : 2023년 09월 09일&#40;토&#41; ~ 10월 01일&#40;일&#41;</p>
                        <p style={{marginBottom:10}}>예선장소 : 전국 선정 개최지 리스트</p>
                        <button onClick={() => window.open("https://docs.google.com/spreadsheets/d/1q8nw1gQQJH1HJ7oP6MUqz8566NB-xCkfIITZDkuCgQ8/edit#gid=0")}>예선 개최지 리스트</button>                                           
                        <p style={{marginBottom:30}}>
                        </p>
                        
                        <p style={{marginBottom:3}}>
                        <strong>·2인 클랜전 및 개인전</strong>
                        </p>
                        <p style={{marginBottom:0}}>제2회 대회에서는 일부 종목들은 2인 클랜전과 개인전으로 진행될 예정입니다.</p>
                        <p style={{marginBottom:30}}></p>
                        <p style={{marginBottom:0}}>2인 클랜전 일반부 : 기즈모, 포션폭발, 센추리, 티켓투라이드</p>
                        <p style={{marginBottom:0}}>2인 클랜전 초등부 : 포션폭발, 티켓투라이드</p>
                        <p style={{marginBottom:0}}>개인전 종목 : 하트오브크라운</p>
                        <p style={{marginBottom:10}}>신청 기간 : 2023년 09월 09일&#40;토&#41; ~ 10월 01일&#40;일&#41;</p>
                        <button onClick={() => window.open("https://forms.gle/tHB69cujUgt2VFJE9")}>2인 클랜전 신청 링크</button>                                           
                        <p style={{marginBottom:10}}></p>
                        <button onClick={() => window.open("https://forms.gle/7S9pigWYHZirZzp18")}>개인전 신청 링크</button>
                        <p style={{marginBottom:30}}></p>

                        <p style={{marginBottom:0}}>각 종목별 안내문은 홈페이지내 '대회일정 및 신청' 에서 확인이 가능합니다.</p>
                        <p style={{marginBottom:30}}></p>

                        <p style={{marginBottom:0}}>
                            <strong>·종목별 세부 일정 안내</strong></p>
                        <p style={{marginBottom:3}}>
                           <small>&#40;두손가락으로 키워서 보실 수 있습니다&#41;</small>
                           <p style={{marginBottom:30}}>
                            </p>
                           </p>
                        <p>
                        <img className='mbkoschedule' src={img77} width="100%"></img>
                        </p>
                        <p style={{marginBottom:30}}>
                        </p>

                        <p style={{marginBottom:3}}>
                        <strong>·대회문의</strong>
                        </p>
                        <p style={{marginBottom:0}}>
                            KbSF 사무국: 010-2251-2630
                            </p>
                        <p style={{marginBottom:0}}>
                            MbKO 운영지원부: 010-3372-4091
                           </p>
                        <p style={{marginBottom:30}}>
                        </p>
                        </div>
                        <div className='bottom1 container container1'>
                    <div className='bottom container container1'>
                    </div>      

                    </div>
                </div>

                

                </div>
                
            </div>
            
        </>


    );
}

export default MLG;